import _get from 'lodash/get';


const getSiteMainParametersErrors = state => _get(state, 'siteBuilder.errors');
export const getLoadCreatePreparationError = state => (
  _get(getSiteMainParametersErrors(state), 'loadCreatePreparationError')
);
export const getCreateSiteError = state => (
  _get(getSiteMainParametersErrors(state), 'createSiteError')
);
export const getEditSiteError = state => (
  _get(getSiteMainParametersErrors(state), 'editSiteError')
);
